export default value => !RegExp(/[^0-9a-z!@#$%\-_]/i).test(value);
